// Carga Leaflet (CSS + JS) una sola vez desde CDN
export function loadLeaflet() {
  return new Promise(function (resolve, reject) {
    if (typeof window !== "undefined" && window.L) {
      return resolve(window.L);
    }

    // Inyecta CSS si no está
    var cssId = "leaflet-css";
    if (!document.getElementById(cssId)) {
      var link = document.createElement("link");
      link.id = cssId;
      link.rel = "stylesheet";
      link.href = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.css";
      document.head.appendChild(link);
    }

    // Inyecta JS si no está
    var jsId = "leaflet-js";
    if (document.getElementById(jsId)) {
      // ya está cargando; espera a que exista window.L
      var check = setInterval(function () {
        if (window.L) {
          clearInterval(check);
          resolve(window.L);
        }
      }, 50);
      return;
    }

    var script = document.createElement("script");
    script.id = jsId;
    script.src = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.js";
    script.async = true;
    script.onload = function () {
      if (window.L) resolve(window.L);
      else reject(new Error("Leaflet no inicializó"));
    };
    script.onerror = function () { reject(new Error("No se pudo cargar Leaflet JS")); };
    document.body.appendChild(script);
  });
}
